var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardPlate"},[_c('div',{staticClass:"cardPlate-head"},[_c('div',{staticClass:"cardPlate-head-tit"},[_vm._v(_vm._s(_vm.title||'推荐商机'))]),_vm._v(" "),_c('div',{staticClass:"cardPlate-head-right"},[_vm._t("headMore")],2)]),_vm._v(" "),_c('div',{staticClass:"cardPlate-cont"},[_vm._t("headCont")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c73706","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/workBench/components/cardPlate.vue
// module id = null
// module chunks = 